"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckAccessToSite = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _react = require("react");
var _paulCorePackage = require("paul-core-package");
var _selectors = require("../redux/selectors");
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CheckAccessToSite = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    children,
    showIf,
    onHasAccess,
    onForbidden
  } = _ref;
  const {
    id: siteId,
    isApproved = false
  } = (0, _reactRedux.useSelector)(_selectors.getDataSite, _paulCorePackage.functions.areEqual);
  const isHasAccess = isApproved;
  const isForbidden = !isApproved;
  (0, _react.useEffect)(() => {
    if (siteId && isHasAccess) {
      onHasAccess === null || onHasAccess === void 0 ? void 0 : onHasAccess({
        siteId,
        type: _constants.CheckAccessToSiteKey.isApproved
      });
    }
  }, [siteId, isHasAccess, onHasAccess]);
  (0, _react.useEffect)(() => {
    if (siteId && isForbidden) {
      onForbidden === null || onForbidden === void 0 ? void 0 : onForbidden({
        siteId,
        type: _constants.CheckAccessToSiteKey.isForbidden
      });
    }
  }, [siteId, isForbidden, onForbidden]);
  if (siteId && showIf === isApproved) return children;
  return null;
});
exports.CheckAccessToSite = CheckAccessToSite;
CheckAccessToSite.propTypes = {
  children: _propTypes.default.element,
  showIf: _propTypes.default.bool,
  onHasAccess: _propTypes.default.func,
  onForbidden: _propTypes.default.func
};